
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios';
import { toast } from 'react-toastify';
import { basePath, formatDate, monthData } from '../Constants/constant';
import BulkCVUploader from '../BulkCVUploader/BulkCVUploader';
import Loader from '../Usables/Loader';
import NoRecords from '../Usables/NoRecords';
import Pagination from '../Usables/Pagination';
import Loading2 from '../Usables/Loading2';
import TooltipComponent from '../Usables/TooltipComponent';
import ToggleArrow from '../Usables/ToggleArrow';
import { SearchField } from '../Usables/InputField';
import { DownloadButton, ExcelExportBtn, ExcelImportBtn, FilterBtn, PdfImportBtn } from '../Usables/Buttons';
import FilterPanel from '../Usables/FilterPanel';
import RefreshButton from '../Usables/RefreshButton';
import PageBanner from '../Usables/PageBanner';
import CvExcelList from './CvExcelList';
import { AppContext } from '../ContextApi/ContextApi';
import Swal from 'sweetalert2';
import CloseModal from '../Usables/CloseModal';
import EditCandidate from '../Usables/EditCandidate';
import { SaveIcon } from '../Usables/IconButtons';


const CvManagement = () => {
    const tableRef = useRef(null);
    const {apiHeaderJSON, apiHeaderFile} = useContext(AppContext)
    const [scrollPosition, setScrollPosition] = useState(0);
    const [expandedRow, setExpandedRow] = useState(null);
    const [allCvReport, setAllCvReport] = useState([]);
    const [excelFile, setExcelFile] = useState(false);
    const [cvFile, setCvFile] = useState(false);
    const [cvUploadView, setCvUploadView] = useState(false);
    const [bulkCvUploadView, setBulkCvUploadView] = useState(false);
    const [excelUploadView, setexcelUploadView] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(true);
    const [filterPanel, setFilterPanel] = useState(false);
    const [loadingUploadCv, setLoadingUploadCv] = useState(false);
    const [loadingUploadExcel, setLoadingUploadExcel] = useState(false);
    const [cvExcelListModal, setCvExcelListModal] = useState(false);
    const [duplicateEntries, setDuplicateEntries] = useState([]);
    const [validationErrors, setvalidationErrors] = useState([]);
    const [formData, setFormData] = useState({});
    const [editRemark, setEditRemark] = useState(false);
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [isChanged, setIsChanged] = useState({getListChanged: false});
    const [filterData, setFilterData] = useState({uploadStatus: "1", candidateName: "", jobTitle: "", phone: "", secondary_phone: "",
        email: "", secondaryEmail:"", secondaryPhone:"", gender: "", skills: "", summary: "",
        industry: "", currentCompany: "", currentDesignation: "", currentLocation: "", experience: "", minExperience:"",
        maxExperience: "", minAnnualSalary: "", maxAnnualSalary:"", ugDegree: "", ugPgDegree: "", ugSpecialization: "",
        ugPgSpecialization: "", ugDegreeSpecialization:"", pgDegree: "", pgSpecialization: "", functionArea: "", preferredLocation: "",
        annualSalary: "", noticePeriod: "", age: "", workPermit: "", maritalStatus: "", fromDate: "", toDate: "",
        dobFromDate: "", dobToDate: "", orderBy: "uploaded_at", orderDirection: "DESC"
    });
    
    const handleExport = async () => {
        try {
            const response = await axios.get(`${basePath}/getCVs`, {
                responseType: 'blob', // Ensure response is treated as a blob
                params:{
                    download:'yes',
                    id:localStorage.getItem("userId"),
                    filter:JSON.stringify(filterData),
                    limit:pagination.limit,
                    page:pagination.page
                },
                headers:apiHeaderJSON
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CV_Management_Export.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link); 
        } catch (error) {
            console.error('Error exporting jobs:', error); 
        }
    };
    const handleExportTemplate = async () => {
        try {
            Swal.fire({
                title: 'Please wait...',
                html: 'Downloading...',
                allowOutsideClick: false,
                didOpen: () => {Swal.showLoading();}
            });
            const response = await axios.get(`${basePath}/getCVExcelImportTemplate?download=yes`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers: apiHeaderJSON
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CV Excel Import.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            Swal.close();
        } catch (error) {
            // console.error('Error exporting jobs:', error);
            Swal.close();
        }
    };
    const handleExportList = async () => {
        setCvExcelListModal(true);
    };
    
    const getList = useCallback(async()=> {
        try {
            const res = await axios.get(`${basePath}/getCVs`,{
                params:{
                    limit:pagination?.limit,
                    page:pagination?.page,
                    filter:JSON.stringify(filterData)
                },
                headers:apiHeaderJSON
            });
            // console.log("res.data=====>>>>>>", res.data);
            setAllCvReport(res?.data?.report);
            setPagination({
                ...pagination,
                totalPages: res?.data?.pages,
                totalRecords: res?.data?.totalRecords
            });
            // tableContainerRef.current.scrollTop = 0;
            setLoading(false);
            setLoadingFilter(false);
            if (filterPanel) setFilterPanel(false);
            // console.log("filterData====>>>>> 1 ",filterData);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
    },[pagination, filterData, apiHeaderJSON, filterPanel]);

    useEffect(() => {
        if (isChanged?.getListChanged) {
            getList();
            setIsChanged({ ...isChanged, getListChanged: false});
        }
    }, [isChanged?.getListChanged]);


    useEffect(() => {
        setLoading("1");
        getList();
    }, []);

    const handleCvSort = (columnName) => {
        if (filterData?.orderBy === columnName) {
            if (filterData?.orderDirection === "DESC") {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
            }
            else {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'DESC' });
            }
        }
        else {
            setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
        }
        setLoading("2");
        setIsChanged({ ...isChanged, getListChanged: true});
    }

    const downloadButton = async (canId, candidateName) => {
        try {
            const response = await fetch(`${basePath}/downloadcv/${canId}`,{
                headers:apiHeaderJSON
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${candidateName.replace(/ /g, "_")}_resume_${new Date().toISOString().split("T")[0]?.split("-")[2]}-${monthData[parseInt(new Date().toISOString().split("T")[0]?.split("-")[1])]}-${new Date().toISOString().split("T")[0]?.split("-")[0]}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url); // Cleanup the URL object
            toast.success(`Resume Dowmloaded Succesfully!!`)
        } catch (error) {
            console.log('There was a problem with the download:', error);
            toast.error("There was a problem with the download!! Please try again later.");
        }
    }

   const handleUploadExcel = () => {
    setLoadingUploadExcel(true);

    const data = new FormData();
    data.append("file", excelFile);

    const options = {
        url: `${basePath}/importexcel`,
        method: "POST",
        headers: apiHeaderFile,
        data: data,
    };

    axios(options)
        .then((response) => {
            setLoadingUploadExcel(false);
            setCvFile(null);
            setExcelFile(null);
            getList();
            toast.success("Excel Uploaded Successfully");

            if (response?.data?.duplicateData?.length) {
                setDuplicateEntries(response.data.duplicateData);
            } else {
                setDuplicateEntries([]);
            }
        })
        .catch((error) => {
            setLoadingUploadExcel(false);
            console.error("Upload failed:", error);

            const responseData = error.response?.data;
            if (error.response?.status === 400) {
                const errorMsg = responseData?.message || "Validation failed";

                toast.error(errorMsg);

                if (responseData?.duplicateData) {
                    setDuplicateEntries(responseData.duplicateData || []);
                }
                if (responseData?.errorRows) {
                    setvalidationErrors(responseData.errorRows|| []);
                }
            } else {

                const fallbackError = responseData?.error || "There is a network or server issue!";
                toast.error(fallbackError);
            }
        });
};
 
    const handleUploadCv = (id) => {
        setLoadingUploadCv(true);
        let data = {
            resume: cvFile
        }
        const options = {
            url: `${basePath}/uploadresume/${id}`,
            method: "PATCH",
            headers: {
                ...apiHeaderJSON
            },
            data: data,
        }
        axios(options)
            .then((response) => {
                if (response.status === 200) {
                    setLoadingUploadCv(false);
                    setCvFile(null);
                    setCvUploadView(false);
                    getList();
                    toast.success("CV Uploaded Successfully");
                    // console.log("==========>>>>>>>>response", response);
                }
                else {
                    setLoadingUploadCv(false);
                    toast.error("Sorry!! Unable to import excel due to server issue. Please Try Again Later.");
                }
            })
            .catch((e) => {
                setLoadingUploadCv(false);
                console.log(e);
                toast.error("There is a network or server issue!! Please Try Again Later.");
            });
    }
    const handleSubmitRemark = () =>{
         setLoadingUploadCv(true);
        const data = {
            recruiter_remarks: formData?.recruiter_remarks,
            id: formData?.id,
        }
        const options = {
            url: `${basePath}/UpdateRecruiterRemarks`,
            method: "POST",
            headers: {
                ...apiHeaderJSON
            },
            data: data,
        }
        Swal.fire({
            title: 'Please wait...',
            html: 'Updating remark...',
            allowOutsideClick: false,
            didOpen: () => {Swal.showLoading();}
        });
        setLoading("3");
        axios(options)
        .then((response) => {
            if (response.status === 200) {
                getList();
                handleClose()
                toast.success( response?.data?.message || "Remark updated Successfully");
                // console.log("==========>>>>>>>>response", response);
            }
            else {
                toast.error(response?.data?.message || "Opps! Something went wrong.");
            }
            setLoading(false);
            Swal.close();
        })
            .catch((e) => {
                setLoading(false);
                Swal.close();
                console.log(e);
                toast.error(e.response?.data?.message || "Opps! Something went wrong.");
            });
    }
    const handleChange = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFormData({ ...formData, [name]: value, });          
    },[formData]);

    const handleEdit = (val) => {
        if (loading) return;
        setFormData({...formData, id: val?.id, recruiter_remarks: val?.recruiter_remarks });
        setEditRemark(true);
    }

    const handleFilter = () => {
        setLoadingFilter("1");
        getList();
    }
    const handleClear = () => {
        setLoadingFilter("2");
        setFilterData({uploadStatus: "1",
            candidateName: "", jobTitle: "",
            phone: "", secondaryPhone: "",
            email: "", secondaryEmail: "",
            gender: "", skills: "",
            summary: "", industry: "",
            currentCompany: "", currentDesignation: "",
            currentLocation: "",
            ugDegree: "", ugPgDegree: "",
            ugSpecialization: "", ugPgSpecialization:"",
            ugDegreeSpecialization: "", pgDegree: "",
            pgSpecialization: "", functionArea: "",
            preferredLocation: "", annualSalary: "",
            minAnnualSalary: "", maxAnnualSalary: "",
            minExperience: "", maxExperience: "",
            noticePeriod: "", age: "",
            workPermit: "", maritalStatus: "",
            fromDate: "", toDate: "",
            dobFromDate: "", dobToDate: "", qualification: "",
            orderBy: "uploaded_at", orderDirection: "DESC"});
        setIsChanged({...isChanged, getListChanged: true});
    }

    const handleFilterCount = useCallback(() => {
        let count = false;   
        const filters = { ...filterData,
            uploadStatus: "",
            orderBy: "",
            orderDirection: "",
        }
        Object.values(filters).forEach(val => {
            if (val !== "" && val !== null && val !== undefined) {
            count++;
            }
    });
    // console.log("count", count); 
    return count;
}, [filterData]);

    const handleLimit = useCallback((e)=> {
        setLoading("2");
        setPagination({...pagination, limit: e.target.value});
        setIsChanged({...isChanged, getListChanged: true});
    },[pagination, isChanged]);

    const handlePrev = useCallback((e)=> {
        if (pagination?.page > 1) {
            setLoading("2");
            setPagination({...pagination, page: pagination?.page - 1});
            setIsChanged({...isChanged, getListChanged: true});
        }
    },[pagination, isChanged]);

    const handleNext = useCallback((e)=> {
        if (pagination?.totalPages > pagination?.page) {
            setLoading("2");
            setPagination({...pagination, page: pagination?.page + 1});
            setIsChanged({...isChanged, getListChanged: true});
        }
    },[pagination, isChanged]);

    const handleChangePage = useCallback((e)=> {
        const { value } = e.target;
        if (pagination?.totalPages >= value ) {
            setPagination({...pagination, page: parseInt(value)});
        }
    },[pagination]);

    const handleSearchPage = useCallback(()=> {
        if (!loading) setLoading("2"); getList();
    },[loading, getList]);

    const toggleRow = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };

    // used for debounce timer 
    const debounceTimerRef = useRef(null);
    const debounceGetList = (delay = 500)=> {
        // it will call getList after defined time (delay)
        if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        }
        debounceTimerRef.current = setTimeout(() => {
            setLoading("2");
            setIsChanged({ ...isChanged, getListChanged: true })
        }, delay);
    }

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setFilterData({ ...filterData, [name]: value, });
        // it will call getList after defined time (delay)
        // debounceGetList();        
    },[filterData]);

    const handleSearchFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setFilterData({ ...filterData, [name]: value, });
        // it will call getList after defined time (delay)
        debounceGetList(1500);    
    },[filterData]);

    const handleFilterPanel = useCallback((event)=> {
        setFilterPanel(!filterPanel);  
    },[filterPanel]);

    const handleClose = ()=> {
        setEditRemark(false);
        setFormData({});
        setFilterPanel(false);
        setexcelUploadView(false);
        setExcelFile(null);
        setDuplicateEntries([]);
        setvalidationErrors([]);
        setCvExcelListModal(false);
        setFilterData({uploadStatus: "1",
        candidateName: "", jobTitle: "",
        phone: "", secondaryPhone: "",
        email: "", secondaryEmail: "",
        gender: "", skills: "",
        summary: "", industry: "",
        currentCompany: "", currentDesignation: "",
        currentLocation: "",
        ugDegree: "", ugPgDegree: "",
        ugSpecialization: "", ugPgSpecialization:"",
        ugDegreeSpecialization: "", pgDegree: "",
        pgSpecialization: "", functionArea: "",
        preferredLocation: "", annualSalary: "",
        minAnnualSalary: "", maxAnnualSalary: "",
        minExperience: "", maxExperience: "",
        noticePeriod: "", age: "",
        workPermit: "", maritalStatus: "",
        fromDate: "", toDate: "",
        dobFromDate: "", dobToDate: "",
        orderBy: "uploaded_at", orderDirection: "DESC"});
    }

    const handleRefresh = () => {
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }


    return (
        <div className='lightBabyGreen baseHeightWidth customScroll'>
            {bulkCvUploadView && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 transition-opacity duration-300 ease-in-out">
                <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full sm:max-w-lg md:max-w-2xl mx-auto p-6 overflow-hidden">
                {/* Top-right close button with hover effect */}
                <button
                    onClick={() => setBulkCvUploadView(!bulkCvUploadView)}
                    className="absolute top-2 right-2 bg-red-500 text-white rounded-[10px] p-2 hover:bg-red-600 hover:scale-110 transition-all duration-300 ease-in-out"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            
                <div
                    className="max-h-[80vh] overflow-y-auto p-4"
                    style={{
                    scrollbarWidth: 'thin', // For Firefox
                    scrollbarColor: 'rgba(0, 0, 0, 0.2) #f3f3f3', // For Firefox
                    }}
                >
                    {/* Inline WebKit Scrollbar Styling */}
                    <style>
                    {`
                        .max-h-[80vh]::-webkit-scrollbar {
                        width: 8px;
                        }
            
                        .max-h-[80vh]::-webkit-scrollbar-thumb {
                        background-color: rgba(0, 0, 0, 0.2);
                        border-radius: 10px;
                        }
            
                        .max-h-[80vh]::-webkit-scrollbar-track {
                        background-color: #f3f3f3;
                        }
                    `}
                    </style>
            
                    {/* Your BulkCVUploader Component */}
                    <BulkCVUploader getCvData={getList} setBulkCvUploadView={setBulkCvUploadView} bulkCvUploadView={bulkCvUploadView} />

                    
                    
                </div>
                </div>
            </div>
            )}
            <div className=''>
                {/* RefreshButton => used for refresh table data */}
                <RefreshButton onClick={handleRefresh} position='fixed' />
                {/* PageBanner => used to show page banner info */}
                <PageBanner pageName='CV Management' pageTitle='Ready to start your day' src='/img/registration.png' alt="Cv Management" />

                {cvUploadView ?
                    <div onClick={(e) => { setCvUploadView(false); }} className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
                        <div onClick={(e) => { e.stopPropagation(); }} className=' bg-white overflow-auto mx-10 mb-5 px-10 py-5 rounded-3xl '>
                            <h1 className='text-center text-xl font-semibold py-2 text-blue-950 mb-4'>Upload Candidate CV</h1>
                            <h1 className=' text-left mb-2'>Candidate Name: <span className=' text-blue-800 font-semibold '>{allCvReport[parseInt(cvUploadView)]?.cand_name}</span></h1>
                            <div className=' flex flex-col justify-center items-center gap-5'>
                                <input onChange={(e) => { setCvFile(e.target.files[0]); }} className=' border-2 rounded-lg px-3 py-1' accept='.pdf' type="file" />
                                {!loadingUploadCv ?
                                    <button onClick={() => {
                                        if (cvFile) {
                                            handleUploadCv(allCvReport[parseInt(cvUploadView)]?.id);
                                        } else {
                                            toast.info("Please choose resume file!!")
                                        }
                                    }} className=" darkPurple text-white font-semibold rounded-lg px-4 text-sm py-1 mx-2 hoverGreen">Upload</button> :
                                    <button className=" darkPurple text-white font-semibold rounded-lg px-4 text-sm py-1 mx-2">Loading...</button>
                                }
                            </div>
                        </div>
                    </div> :
                    null}
                {excelUploadView ? (
                    <div className="w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack" >
                        <div onClick={(e) => {e.stopPropagation();}} className={`bg-white overflow-auto mx-10 mb-5 px-10 py-5 rounded-3xl 
                            ${(duplicateEntries?.length > 0 && validationErrors?.length > 0) ? 
                            "w-full" : 
                            (duplicateEntries?.length > 0 || validationErrors?.length > 0) ? "w-[70vw]" : "w-[50vw]"}`}>
                        <div className="flex flex-col justify-center items-center gap-5">
                            <div className="relative bg-white rounded-2xl w-full mx-auto p-6 overflow-hidden">
                                <h1 className="text-center text-xl font-semibold py-2 text-blue-950 mb-5">
                                    Excel Import
                                </h1>
                                <CloseModal disabled={loading} onClick={handleClose} />
                                <div className='flex items-center justify-center gap-3'>
                                    <input
                                    onChange={(e) => {
                                    setExcelFile(e.target.files[0]);
                                    }}
                                    className="border-2 rounded-lg px-3 py-1"
                                    accept=".xlsx"
                                    type="file"
                                    />
                                    {!loadingUploadExcel ? (
                                        <button
                                        onClick={() => {
                                            if (excelFile) {
                                            handleUploadExcel();
                                            } else {
                                            toast.info("Please choose excel file!!");
                                            }
                                        }}
                                        className="py-2 px-5 rounded-lg bg-green-700 text-white font-semibold hoverGreen"
                                        >
                                        Upload
                                        </button>
                                    ) : (
                                        <button className="py-1 px-5 rounded-lg bg-green-900 text-white font-semibold">
                                        Loading...
                                        </button>
                                    )}
                                    <ExcelExportBtn buttonName="Excel Template" onClick={handleExportTemplate} disabled={loading} />
                                </div>
                                <div className=' flex justify-between flex-row gap-4'>
                                    {duplicateEntries.length > 0 && (
                                    <div className=" flex-1 mt-5 max-h-80 overflow-y-auto bg-gray-100 p-3 rounded-lg border border-gray-300 w-full">
                                        <h2 className='p-2'>Duplicate Entries</h2>
                                        <ul>
                                            {duplicateEntries.map((entry, index) => (
                                            <li
                                                key={index}
                                                className="text-red-500 font-semibold text-sm list-disc ml-5"
                                            >
                                                {`At Row : ${entry?.row} ~ ${entry?.error}.`}
                                            </li>
                                            ))}
                                        </ul>
                                    </div>
                                    )}
                                    {validationErrors.length > 0 && (
                                    <div className=" flex-1 mt-5 max-h-80 overflow-y-auto bg-gray-100 p-3 rounded-lg border border-gray-300 w-full">
                                        <h2 className='p-2'>Validation Errors</h2>
                                        <ul>
                                            {validationErrors.map((entry, index) => (
                                            <li
                                                key={index}
                                                className="text-red-500 font-semibold text-sm list-disc ml-5"
                                            >
                                                {`At Row : ${entry?.row} ~ ${entry?.errors?.join(',')}.`}
                                            </li>
                                            ))}
                                        </ul>
                                    </div>
                                    )}

                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                ) : null}
                {cvExcelListModal && (
                    <CvExcelList onClose={handleClose} />
                )}
                {editRemark && (
                    <section className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
                        <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[40vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
                            <SaveIcon disabled={loading} loading={loading} className=" top-3 left-8" onClick={handleSubmitRemark} />
                            <CloseModal disabled={loading} onClick={handleClose} />
                            <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Update Recruiter Remark</h1>
                            <h2 className=' text-gray-700 mb-1 text-left'>Recruiter Remark:</h2>
                            <textarea name="recruiter_remarks" id="recruiter_remarks" rows="5"
                            className='w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                            disabled={!editRemark} placeholder="Enter remark..." onChange={handleChange}>
                                {formData?.recruiter_remarks}
                            </textarea>
                        </div>
                    </section>
                )}
                {loading === "1" ?
                    <Loader/> :
                    <section ref={tableRef} className='relative bg-white grayBlurShadow rounded-xl px-6 pb-2 pt-4 mt-3'>
                        <div className='flex items-center justify-between mb-2'>
                            <SearchField
                                id="search_all"
                                name="search_all"
                                type="text"
                                disabled={loading}
                                loading={loading === "2"}
                                placeholder="Search here..."
                                value={filterData?.search_all}
                                onChange={handleSearchFilter}
                                loadingFilter={loadingFilter}
                            />
                            <div className=' flex items-center gap-2'>
                                <FilterBtn buttonName="Filters" onClick={handleFilterPanel} filterCount={handleFilterCount} disabled={loading} />
                                <ExcelImportBtn buttonName="Excel Import" onClick={() => { setexcelUploadView(true); }} disabled={loading} />
                                <PdfImportBtn buttonName="CV Upload" onClick={() => { setBulkCvUploadView(!bulkCvUploadView); }} disabled={loading} />
                                <ExcelExportBtn buttonName="Excel Export" onClick={handleExport} disabled={loading} />
                                <ExcelExportBtn buttonName="Excel List" onClick={handleExportList} disabled={loading} />
                            </div>
                            <FilterPanel
                            show={filterPanel}
                            onClose={handleClose}
                            filterData={filterData}
                            disabled={loading}
                            loading={loading}
                            loadingFilter={loadingFilter}
                            onChange={handleChangeFilter}
                            onFilter={handleFilter}
                            onClear={handleClear}
                            />
                        </div>
                        {Array.isArray(allCvReport) && allCvReport?.length >= 1 ? 
                        <>
                            <div className=' tableBody'>
                                <table className='w-full table-fixed border-collapse'>
                                    <thead className='tableHead'>
                                        <tr className=' text-left'>
                                            <th className='whitespace-nowrap text-center w-[11%]'>
                                                <div onClick={() => handleCvSort("uploaded_at")} className='flex item-center gap-2 justify-center w-full cursor-pointer'>
                                                    Upload Date
                                                    {filterData?.orderBy === "uploaded_at" && filterData?.orderDirection === "ASC" ?
                                                        <img className='w-4 h-4 mt-1' src="/img/upArrow.png" alt="up" /> :
                                                        filterData?.orderBy === "uploaded_at" && filterData?.orderDirection === "DESC" ?
                                                            <img className='w-4 h-4 mt-1' src="/img/downArrow.png" alt="up" /> :
                                                            <img className='w-4 h-4 mt-1' src="/img/upDownArrow.png" alt="up" />}
                                                </div>
                                            </th>
                                            <th className='whitespace-nowrap'>
                                                <div onClick={() => handleCvSort("cand_name")} className='flex item-center gap-2 justify-start w-full cursor-pointer'>
                                                    Candidate name
                                                    {filterData?.orderBy === "cand_name" && filterData?.orderDirection === "ASC" ?
                                                        <img className='w-4 h-4 mt-1' src="/img/upArrow.png" alt="up" /> :
                                                        filterData?.orderBy === "cand_name" && filterData?.orderDirection === "DESC" ?
                                                            <img className='w-4 h-4 mt-1' src="/img/downArrow.png" alt="up" /> :
                                                            <img className='w-4 h-4 mt-1' src="/img/upDownArrow.png" alt="up" />}
                                                </div>
                                            </th>
                                            <th style={{ minWidth: "13rem" }} className='whitespace-nowrap'>
                                                <div onClick={() => handleCvSort("job_title")} className='flex item-center gap-2 justify-start w-full cursor-pointer'>
                                                    Job/Experinece
                                                    {filterData?.orderBy === "job_title" && filterData?.orderDirection === "ASC" ?
                                                        <img className='w-4 h-4 mt-1' src="/img/upArrow.png" alt="up" /> :
                                                        filterData?.orderBy === "job_title" && filterData?.orderDirection === "DESC" ?
                                                            <img className='w-4 h-4 mt-1' src="/img/downArrow.png" alt="up" /> :
                                                            <img className='w-4 h-4 mt-1' src="/img/upDownArrow.png" alt="up" />}
                                                </div>
                                            </th>
                                            <th className='whitespace-nowrap'>
                                                <div onClick={() => handleCvSort("current_location")} className='flex item-center gap-2 justify-start w-full cursor-pointer'>
                                                Loaction Curr./Pref.
                                                {filterData?.orderBy === "current_location" && filterData?.orderDirection === "ASC" ?
                                                    <img className='w-4 h-4 mt-1' src="/img/upArrow.png" alt="up" /> :
                                                    filterData?.orderBy === "current_location" && filterData?.orderDirection === "DESC" ?
                                                        <img className='w-4 h-4 mt-1' src="/img/downArrow.png" alt="up" /> :
                                                        <img className='w-4 h-4 mt-1' src="/img/upDownArrow.png" alt="up" />}
                                                </div>
                                            </th>                                        
                                            <th className='whitespace-nowrap'>
                                                <div onClick={() => handleCvSort("current_company")} className='flex item-center gap-2 justify-start w-full cursor-pointer'>
                                                    Current Company
                                                    {filterData?.orderBy === "current_company" && filterData?.orderDirection === "ASC" ?
                                                        <img className='w-4 h-4 mt-1' src="/img/upArrow.png" alt="up" /> :
                                                        filterData?.orderBy === "current_company" && filterData?.orderDirection === "DESC" ?
                                                            <img className='w-4 h-4 mt-1' src="/img/downArrow.png" alt="up" /> :
                                                            <img className='w-4 h-4 mt-1' src="/img/upDownArrow.png" alt="up" />}
                                                </div>
                                            </th>
                                            <th className='text-center w-[8%]'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='tableBody'>
                                        {
                                            Array.isArray(allCvReport) && allCvReport?.map((val, idx) => {
                                                return (
                                                <>
                                                    <tr key={idx} className={`${expandedRow === val.id ? " sticky z-10 shadow top-12 border-x-2 border-t-2 rounded-t-lg left-0 bg-white" : "relative"}  backWhite font-semibold text-sm py-2 text-left`}>
                                                        <td className=''>
                                                            <div className='flex gap-1 items-center'>
                                                                <ToggleArrow isOpen={expandedRow === val.id} onToggle={()=> toggleRow(val?.id)} />
                                                                <span className='whitespace-nowrap'>
                                                                    {val?.uploaded_at.split("T")[0].split("-")[2]} {monthData[parseInt(val?.uploaded_at.split("T")[0].split("-")[1])]} {val?.uploaded_at.split("T")[0].split("-")[0]}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className=' overflow-hidden flex flex-col'>
                                                            <TooltipComponent name={val?.cand_name?.length > 22 ? val?.cand_name : "" }>
                                                                <span className={`line-clamp-1 text-ellipsis`}>{(val?.cand_name === "NA" || !val?.cand_name) ? "--" : val?.cand_name}</span>
                                                            </TooltipComponent>
                                                            <TooltipComponent name={val?.email?.length > 27 ? val?.email : "" }>
                                                                <span className={`text-sm line-clamp-1 text-ellipsis text-gray-400`}>{(val?.email === "NA" || !val?.email) ? "--" : val?.email}</span>
                                                            </TooltipComponent>
                                                        </td>
                                                        <td>
                                                            <div className=' overflow-hidden flex flex-col'>
                                                                <TooltipComponent name={val?.current_designation?.length > 27 ? val?.current_designation : "" }>
                                                                    <span className={`line-clamp-1 text-ellipsis  `}>{(val?.current_designation === "NA" || !val?.current_designation) ? "--" : val?.current_designation}</span>
                                                                </TooltipComponent>
                                                                <span className={`text-sm line-clamp-1 text-ellipsis text-gray-400 `}>{(val?.experience === "NA" || !val?.experience) ? "--" : `Exp. ${val?.experience} ${val?.experience > 1 ? "Yrs." : "Yr."}`}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className=' overflow-hidden flex flex-col'>
                                                                <TooltipComponent name={val?.current_location?.length > 27 ? val?.current_location : "" }>
                                                                    <span className={`line-clamp-1 text-ellipsis  `}>{(val?.current_location === "NA" || !val?.current_location) ? "--" : val?.current_location}</span>
                                                                </TooltipComponent>
                                                                <TooltipComponent name={val?.preferred_location?.length > 27 ? val?.preferred_location : "" }>
                                                                    <span className={`text-sm line-clamp-1 text-ellipsis text-gray-400 `}>{(val?.preferred_location === "NA" || !val?.preferred_location) ? "--" : val?.preferred_location}</span>
                                                                </TooltipComponent>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className=' overflow-hidden flex flex-col'>
                                                                <TooltipComponent name={val?.current_company?.length > 26 ? val?.current_company : "" }>
                                                                    <span className={`line-clamp-1 text-ellipsis  `}>{(val?.current_company === "NA" || !val?.current_company) ? "--" : val?.current_company}</span>
                                                                </TooltipComponent>
                                                                <TooltipComponent name={val?.current_designation?.length > 27 ? val?.current_designation : "" }>
                                                                    <span className={`text-sm line-clamp-1 text-ellipsis text-gray-400 `}>{(val?.current_designation === "NA" || !val?.current_designation) ? "--" : val?.current_designation}</span>
                                                                </TooltipComponent>
                                                            </div>
                                                        </td>
                                                        <td className=' text-center'>
                                                            <DownloadButton data={val} onClick={()=> downloadButton(val?.id, val?.cand_name)} tooltipName="Download Resume" disabled={!val?.resume} />
                                                        </td>
                                                    </tr>
                                                    {expandedRow === val.id && (
                                                    <tr className=' ' >
                                                        <td colSpan={6} className=" text-sm" style={{ padding:"0px 0px 0.5rem 0px" }}>
                                                        <div className="grid grid-cols-4 gap-2 shadow border-b-2 border-x-2 bg-gray-50 px-3 rounded-b-lg py-3 animate-slideIn">
                                                            {/* <div className='grid grid-cols-2 border rounded-lg bg-white'> */}
                                                                <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                    <label className=' text-gray-700 mb-1'>Uploaded By:</label>
                                                                    <div className={`flex w-full`}>
                                                                        <TooltipComponent name={val?.User?.name?.length > 30 ? val?.User?.name : "" }>
                                                                            <p className={`${val?.User?.name?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                                {val?.User?.name === "NA" || !val?.User?.name ? "--" : val?.User?.name}
                                                                            </p>
                                                                        </TooltipComponent>
                                                                    </div>
                                                                </div>
                                                                <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                    <label className=' text-gray-700 mb-1'>Mobile No:</label>
                                                                    <div className={`flex w-full`}>
                                                                        <TooltipComponent name={val?.phone?.length > 30 ? val?.phone : "" }>
                                                                            <p className={`${val?.phone?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                                {(val?.phone === "NA" && !val?.phone) ? "--" : val?.phone}
                                                                            </p>
                                                                        </TooltipComponent>
                                                                    </div>
                                                                </div>
                                                                <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                    <label className=' text-gray-700 mb-1'>Secondary No:</label>
                                                                    <div className={`flex w-full`}>
                                                                        <TooltipComponent name={val?.secondary_phone?.length > 30 ? val?.secondary_phone : "" }>
                                                                            <p className={`${val?.secondary_phone?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                                {(val?.secondary_phone === "NA" || !val?.secondary_phone) ? "--" : val?.secondary_phone}
                                                                            </p>
                                                                        </TooltipComponent>
                                                                    </div>
                                                                </div>
                                                            {/* </div> */}
                                                            {/* <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Job Title:</label>
                                                                <div className={`flex w-full`}>
                                                                    <TooltipComponent name={val?.job_title?.length > 30 ? val?.job_title : "" }>
                                                                        <p className={`${val?.job_title?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                            {(val?.job_title === "NA" || !val?.job_title) ? "--" : val?.job_title}
                                                                        </p>
                                                                    </TooltipComponent>
                                                                </div>
                                                            </div> */}
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Function Area:</label>
                                                                <div className={`flex w-full`}>
                                                                    <TooltipComponent name={val?.func_area?.length > 30 ? val?.func_area : "" }>
                                                                        <p className={`${val?.func_area?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                            {(val?.func_area === "NA" || !val?.func_area) ? "--" : val?.func_area}
                                                                        </p>
                                                                    </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Industry:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.industry?.length > 30 ? val?.industry : "" }>
                                                                    <p className={`${val?.industry?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.industry === "NA" || !val?.industry) ? "--" : val?.industry}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Annual Salary:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.annual_salary?.length > 30 ? val?.annual_salary : "" }>
                                                                    <p className={`${val?.annual_salary?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.annual_salary === "NA" || !val?.annual_salary) ? "--" : val?.annual_salary}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Notice Period:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.notice_period?.length > 30 ? val?.notice_period : "" }>
                                                                    <p className={`${val?.notice_period?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.notice_period === "NA" || !val?.notice_period) ? "--" : val?.notice_period}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>UG Degree:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.ug_degree?.length > 30 ? val?.ug_degree : "" }>
                                                                    <p className={`${val?.ug_degree?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.ug_degree === "NA" || !val?.ug_degree) ? "--" : val?.ug_degree}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>UG Specialization:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.ug_spl?.length > 30 ? val?.ug_spl : "" }>
                                                                    <p className={`${val?.ug_spl?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.ug_spl === "NA" || !val?.ug_spl) ? "--" : val?.ug_spl}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>PG Degree:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.pg_degree?.length > 30 ? val?.pg_degree : "" }>
                                                                    <p className={`${val?.pg_degree?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.pg_degree === "NA" || !val?.pg_degree) ? "--" : val?.pg_degree}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>PG Specialization:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.pg_spl?.length > 30 ? val?.pg_spl : "" }>
                                                                    <p className={`${val?.pg_spl?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.pg_spl === "NA" || !val?.pg_spl) ? "--" : val?.pg_spl}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Gender:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.gender?.length > 30 ? val?.gender : "" }>
                                                                    <p className={`${val?.gender?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.gender === "NA" || !val?.gender) ? "--" : val?.gender}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Marital Status:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.marital_status?.length > 30 ? val?.marital_status : "" }>
                                                                    <p className={`${val?.marital_status?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {(val?.marital_status === "NA" || !val?.marital_status) ? "--" : val?.marital_status}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            {/* <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Work Permit:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.work_permit?.length > 30 ? val?.work_permit : "" }>
                                                                    <p className={`${val?.work_permit?.length > 30 ? "cursor-pointer" : "" } text-green-800 `}>
                                                                        {val?.work_permit === "NA" ? "--" : val?.work_permit}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div> */}
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Date Of Birth:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.dob ? formatDate(val?.dob) : ""}>
                                                                    <p className={` text-green-800 `}>
                                                                        {val?.dob ? formatDate(val?.dob) : "--"}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Age:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.age ? `${val?.age} Yrs.` : ""}>
                                                                    <p className={` text-green-800 `}>
                                                                        {val?.age ? `${val?.age} Yrs.` : "--"}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Resume Updated Date-time:</label>
                                                                <div className={`flex w-full`}>
                                                                <TooltipComponent name={val?.resume_updated_datetime ? formatDate(val?.resume_updated_datetime) : ""}>
                                                                    <p className={` text-green-800 `}>
                                                                        {val?.resume_updated_datetime ? formatDate(val?.resume_updated_datetime) : "--"}
                                                                    </p>
                                                                </TooltipComponent>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <div className=' flex justify-between items-center w-full'>
                                                                    <label className=' text-gray-700 mb-1'>Recruiter Remark:</label>
                                                                    <button onClick={()=> handleEdit(val)} className={`${"text-green-700 px-2 rounded bg-green-200 hover:text-green-600"}`}>Edit</button>
                                                                </div>
                                                                <div className={`flex w-full`}>
                                                                    <p className={` text-green-800 `}>
                                                                        {val?.recruiter_remarks || "--"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Candidate Remark:</label>
                                                                <div className={`flex w-full`}>
                                                                    <p className={` text-green-800 `}>
                                                                        {val?.cv_reminder_histories[0]?.candidate_remarks ? val?.cv_reminder_histories[0]?.candidate_remarks : "--"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Skills:</label>
                                                                <div className={`flex w-full`}>
                                                                    <p className={` text-green-800  text-left`}>
                                                                        {val?.skills ? val?.skills : "--"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-start px-3 pb-2 border rounded-lg bg-white'>
                                                                <label className=' text-gray-700 mb-1'>Summary:</label>
                                                                <div className={`flex w-full`}>
                                                                    <p className={` text-green-800  text-left`}>
                                                                        {val?.summary ? val?.summary : "--"}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        </td>
                                                    </tr>)}
                                                </>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                {loading === "2" && <Loading2/> }
                            </div>
                            <Pagination disabled={loading === "2"} onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                            limit={pagination?.limit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                            disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                            onChangePage={handleChangePage} onSearchPage={handleSearchPage}
                            />
                        </> :
                        <NoRecords/>}
                    </section>
                }
            </div>
        </div >
       
    );
}
export default CvManagement;
